/* Bandenmeesters — canonical information, knowledge and legal page behaviour. */
(()=>{
  'use strict';
  if(window.__bmInfoPagesRuntime)return;
  window.__bmInfoPagesRuntime=true;

  const meaningful=node=>node.textContent?.trim()||node.querySelector?.('img,svg,ul,ol,table,form,blockquote');

  const sectionise=(container,prefix='bm-section')=>{
    if(!container||container.dataset.bmSectionised==='true')return [...(container?.querySelectorAll?.(':scope > .bm-rich-section')||[])];
    const nodes=[...container.childNodes];
    if(!nodes.some(node=>node.nodeType===1&&node.tagName==='H2'))return [];
    container.dataset.bmSectionised='true';
    const frag=document.createDocumentFragment();
    let intro=document.createElement('div');
    intro.className='bm-rich-intro';
    frag.appendChild(intro);
    let current=intro;
    let sectionIndex=0;
    nodes.forEach(node=>{
      if(node.nodeType===1&&node.tagName==='H2'){
        sectionIndex+=1;
        const section=document.createElement('section');
        section.className='bm-rich-section';
        section.id=`${prefix}-${sectionIndex}`;
        section.dataset.bmReveal='';
        const number=document.createElement('span');
        number.className='bm-rich-section__number';
        number.setAttribute('aria-hidden','true');
        number.textContent=String(sectionIndex).padStart(2,'0');
        section.append(number,node);
        frag.appendChild(section);
        current=section;
      }else current.appendChild(node);
    });
    if(!meaningful(intro))intro.remove();
    container.appendChild(frag);
    return [...container.querySelectorAll(':scope > .bm-rich-section')];
  };

  const tocFor=(sections,label='Op deze pagina')=>{
    if(!sections||sections.length<2)return null;
    const nav=document.createElement('nav');
    nav.className='bm-generated-toc';
    nav.setAttribute('aria-label',label);

    const title=document.createElement('strong');
    title.textContent=label;
    const items=document.createElement('div');

    sections.forEach((section,index)=>{
      const heading=section.querySelector('h2');
      const text=heading?.textContent?.trim()||`Onderdeel ${index+1}`;
      const link=document.createElement('a');
      link.href=`#${section.id}`;

      const number=document.createElement('span');
      number.textContent=String(index+1).padStart(2,'0');
      link.append(number,document.createTextNode(text));
      items.append(link);
    });

    nav.append(title,items);
    return nav;
  };

  const enhanceArticle=()=>{
    const article=document.querySelector('.article-template');
    const content=article?.querySelector('.article-template-content');
    if(!article||!content||article.dataset.bmEditorialReady==='true')return;
    article.dataset.bmEditorialReady='true';

    const title=article.querySelector('.article-template-title');
    const artworkTemplate=document.querySelector('[data-bm-article-artwork-template]');
    if(title&&artworkTemplate?.content){
      const hero=document.createElement('div');
      hero.className='bm-article-artwork';
      hero.append(artworkTemplate.content.cloneNode(true));
      title.insertAdjacentElement('afterend',hero);
    }

    const sections=sectionise(content,'artikel');
    const toc=tocFor(sections,'In dit artikel');
    let readingShell=null;
    if(toc){
      readingShell=document.createElement('div');
      readingShell.className='bm-article-reading-layout';
      content.before(readingShell);
      readingShell.append(toc,content);
    }

    const back=document.createElement('div');
    back.className='bm-article-next';
    back.dataset.bmReveal='';
    back.innerHTML='<div><span>VOLGENDE STAP</span><strong>Controleer daarna jouw exacte auto en de specifieke set.</strong><p>Gebruik de voertuigselector en kijk op de productpagina altijd naar de concrete maatvoering en staat.</p></div><div><a href="/#voertuigselector">Kies je auto →</a><a href="/pages/contact">Vraag advies →</a></div>';
    (readingShell||content).insertAdjacentElement('afterend',back);
  };

  const enhancePolicy=()=>{
    const container=document.querySelector('.shopify-policy__container');
    const body=container?.querySelector('.shopify-policy__body');
    const title=container?.querySelector('.shopify-policy__title');
    if(!container||!body||container.dataset.bmPolicyReady==='true')return;
    container.dataset.bmPolicyReady='true';
    const index=document.createElement('nav');
    index.className='bm-policy-index';
    index.dataset.bmReveal='';
    index.setAttribute('aria-label','Juridische informatie');
    index.innerHTML='<div><span>JURIDISCH & PRIVACY</span><strong>Duidelijke documenten, gescheiden van praktische service-info.</strong></div><div><a href="/pages/algemene-verkoopvoorwaarden">Voorwaarden</a><a href="/policies/privacy-policy">Privacy</a><a href="/pages/cookiebeleid">Cookies</a><a href="/pages/wettelijke-vermeldingen">Wettelijke info</a><a href="/pages/online-herroepen">Herroepen</a></div>';
    if(title)title.before(index);else container.prepend(index);
    const sections=sectionise(body,'beleid');
    const toc=tocFor(sections,'In dit document');
    if(toc){
      const shell=document.createElement('div');
      shell.className='bm-policy-reading-layout';
      body.before(shell);
      shell.append(toc,body);
    }
  };

  const run=()=>{enhanceArticle();enhancePolicy();};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true});else run();
  document.addEventListener('shopify:section:load',()=>window.requestAnimationFrame(run));
})();